module.exports = __webpack_public_path__ + "assets/img/home-midea-light.cc28fa21.png";